import React from 'react'
import * as ReactDOM from "react-dom";
import AutoComplete from './AutoComplete.js';


ReactDOM.render(<AutoComplete />, document.getElementById("root"));
